import * as React from 'react';
import { SvgIcon } from '@material-ui/core';

const Ensemble = props => {
  return (
    <SvgIcon {...props} width="33" height="33" viewBox="0 0 33 33">
      <g transform="translate(0 0.146)">
        <rect fill="none" width="33" height="33" transform="translate(0 -0.146)" />
        <path
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M32.255,18.257H30.284V15.628A2.628,2.628,0,0,0,27.655,13H6.628A2.628,2.628,0,0,0,4,15.628V26.142A2.628,2.628,0,0,0,6.628,28.77H27.655a2.628,2.628,0,0,0,2.628-2.628V23.513h1.971Z"
          transform="translate(-1.372 -4.458)"
        />
        <path d="M14,24.285,21.228,21v2.628l5.914-.657-7.228,3.285V23.628Z" transform="translate(-4.801 -7.201)" />
      </g>
    </SvgIcon>
  );
};

export default Ensemble;
